import { clone } from "lodash";
import { checkEU28 } from "./utils/checkEU28";
import { ISO2CDbyISO3CD } from "./utils/ISO2CDbyISO3CD";
import { MapDataCountry } from "../../../models/MapDataCountry";
import { MapDataRange } from "../../../models/MapDataRange";
import { eu28GeoJSON } from "../../ChartMap";

const factoryFeaturePipe = (featureIteration: (feature: any) => void) => (geoJSON) => {
  const nextGeoJSON = clone(geoJSON);
  nextGeoJSON.features.forEach(featureIteration);
  return nextGeoJSON;
};

export const colorPipe = (ranges: MapDataRange[]) =>
  factoryFeaturePipe((feature) => {
    const { properties } = feature;
    if (properties) {
      const { roundedValue, notInSource } = properties;
      if (notInSource) {
        properties["color"] = "rgb(159, 159, 159)";
      } else {
        const range = ranges.find((it) => it.check(roundedValue));
        if (range) {
          properties["color"] = range.color;
        } else {
          properties["color"] = "rgb(235, 235, 235)";
        }
      }
    }
  });

export const setISO2CDPipe = factoryFeaturePipe((feature) => {
  const { properties } = feature;
  if (properties) {
    const { ISO3CD } = properties;
    properties["ISO2CD"] = ISO2CDbyISO3CD(ISO3CD);
  }
});

export const setIsEU28Pipe = factoryFeaturePipe((feature) => {
  const { properties } = feature;
  if (properties) {
    const { ISO2CD } = properties;
    properties["EU28"] = checkEU28(ISO2CD);
  }
});

export const setDataPipe = (data: Map<string, MapDataCountry>) =>
  factoryFeaturePipe((feature) => {
    const { properties } = feature;
    if (properties) {
      const { ISO2CD } = properties;
      properties["notInSource"] = !data.has(ISO2CD);
      const payload = data.get(ISO2CD);
      properties["hasData"] = data.has(ISO2CD) && payload?.value !== undefined && payload?.value !== null;
      properties["value"] = payload?.value;
      properties["roundedValue"] = payload?.roundedValue;
      properties["displayValue"] = payload?.displayValue;
      properties["name"] = payload?.name;
      properties["source"] = payload?.source;
      properties["unit"] = payload?.unit?.name;
    }
  });

export function eu28Pipe(_) {
  return eu28GeoJSON;
}
